'use client';

import Image from 'next/image';
import { Button } from '@nextui-org/react';

import { Link } from '@/shared/navigation';
import { ROUTES } from '@/shared/routes/routes';

const PORTRAIT_SRC = '/hero.webp';

export const HomeMiniAbout = () => {
  return (
    <section
      className="w-full py-10 md:py-14"
      aria-labelledby="home-mini-about-heading"
    >
      <div className="flex flex-col items-center gap-6 rounded-2xl border border-default-200 bg-content1/40 p-6 shadow-sm backdrop-blur-sm md:flex-row md:gap-10 md:p-8 dark:bg-default-100/10">
        <div className="shrink-0">
          <Image
            src={PORTRAIT_SRC}
            alt="Марина Камбур"
            width={200}
            height={200}
            className="h-40 w-40 rounded-xl object-cover md:h-48 md:w-48"
            sizes="(max-width: 768px) 160px, 192px"
          />
        </div>
        <div className="min-w-0 text-center md:text-left">
          <h2
            id="home-mini-about-heading"
            className="text-xl font-semibold text-foreground md:text-2xl"
          >
            Марина Камбур
          </h2>
          <p className="mt-2 leading-relaxed text-default-600">
            Автор мастер-классов — Марина Камбур: понятные схемы, милые игрушки и
            поддержка на каждом шагу. Загляни в раздел «Обо мне» — расскажу
            историю и вдохновение подробнее.
          </p>
          <Button
            as={Link}
            href={ROUTES.about}
            prefetch
            // text-amber-700: жёлтый text-warning на белом давал контраст
            // ~1.9:1 — ниже WCAG AA 4.5:1 (аудит Lighthouse). Рамка остаётся
            // жёлтой (борд не текст, на него норматив не распространяется).
            className="mt-5 font-semibold text-amber-700"
            color="warning"
            variant="bordered"
            radius="full"
          >
            Подробнее об авторе
          </Button>
        </div>
      </div>
    </section>
  );
};
